<div class="smile-field-container">
    <div class="position-relative">
        @if (replyTemplateService.allReplyTemplates.length && quillEditor) {
            <sb-quill-reply-templates
                parentContainerId="ticket-right-panel-content"
                [quillEditor]="quillEditor"
                [attachments]="attachments"
                [note]="note">
            </sb-quill-reply-templates>
        }
        <app-sb-quill-mention
            [quillEditor]="quillEditor"
            [usersToMention]="noteService.allUsers"
            parentContainerId="ticket-right-panel-content">
        </app-sb-quill-mention>
        <quill-editor
            id="{{ 'note-editor-' + noteId }}"
            [ngClass]="{ 'hide-toolbar': !toolbarHelperService.isShowFormatting }"
            [(ngModel)]="note.html"
            (onContentChanged)="onNoteTextChanged()"
            (onEditorCreated)="onEditorCreated($event)"
            [modules]="quillConfig"
            placeholder="{{ 'Write comment here...' | translate }}"
            format="html">
            <div
                id="{{ 'note-editor-toolbar-' + noteId }}"
                #toolbarContainer
                class="{{ toolbarSize }}-toolbar"
                quill-editor-toolbar
                [hidden]="!toolbarHelperService.isShowFormatting">
                <select class="ql-color quill-tooltip" [attr.data-tooltip]="'Text color' | translate"></select>
                <select
                    class="ql-background quill-tooltip"
                    [attr.data-tooltip]="'Background color' | translate"></select>
                <select class="ql-align quill-tooltip" [attr.data-tooltip]="'Alignment' | translate"></select>
                <button class="ql-bold" tooltip="{{ 'Bold' | translate }}" container="body"></button>
                <button
                    class="ql-italic xsmall-toolbar__optional-btn"
                    tooltip="{{ 'Italic' | translate }}"
                    container="body"></button>
                <button
                    class="ql-underline xsmall-toolbar__optional-btn"
                    tooltip="{{ 'Underline' | translate }}"
                    container="body"></button>
                <button
                    class="ql-strike small-toolbar__optional-btn"
                    tooltip="{{ 'Strikethrough' | translate }}"
                    container="body"></button>
                <button
                    class="ql-blockquote small-toolbar__optional-btn"
                    tooltip="{{ 'Blockquote' | translate }}"
                    container="body"></button>
                <!-- <button class="ql-blockquote"></button>
                <button class="ql-code-block"></button>
                <button class="ql-indent" value="-1"></button>
                <button class="ql-indent" value="+1"></button>
                <button class="ql-list" value="ordered"></button>
                <button class="ql-list" value="bullet"></button>
                <button class="ql-direction" value="rtl"></button>
                <button class="ql-header" value="1"></button>
                <button class="ql-header" value="2"></button>
                <button class="ql-clean"></button>
                <button class="ql-link"></button>
                <button class="ql-image"></button> -->
                <div id="{{ 'note-editor-options-' + noteId }}" sbClickOutside (sbClickOutside)="hideToolbar()">
                    <button class="btn-icon options-button" (click)="toggleToolbar()">
                        <sb-inline-svg
                            class="icon"
                            aria-label="My icon"
                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/More icon.svg'">
                        </sb-inline-svg>
                    </button>
                    <div class="options-block">
                        <!-- <select class="ql-color"></select>
                        <select class="ql-background"></select>
                        <select class="ql-align"></select>
                        <button class="ql-bold"></button>
                        <button class="ql-italic"></button> -->
                        <button
                            class="ql-italic xsmall-toolbar__optional-btn"
                            tooltip="{{ 'Italic' | translate }}"
                            container="body"
                            (click)="hideToolbar()"></button>
                        <button
                            class="ql-underline xsmall-toolbar__optional-btn"
                            tooltip="{{ 'Underline' | translate }}"
                            container="body"
                            (click)="hideToolbar()"></button>
                        <button
                            class="ql-strike small-toolbar__optional-btn"
                            tooltip="{{ 'Strikethrough' | translate }}"
                            container="body"
                            (click)="hideToolbar()"></button>
                        <button
                            class="ql-blockquote small-toolbar__optional-btn"
                            tooltip="{{ 'Blockquote' | translate }}"
                            container="body"
                            (click)="hideToolbar()"></button>
                        <button
                            class="ql-code-block"
                            tooltip="{{ 'Code' | translate }}"
                            container="body"
                            (click)="hideToolbar()"></button>
                        <button
                            class="ql-indent"
                            tooltip="{{ 'Decrease indent' | translate }}"
                            container="body"
                            value="-1"
                            (click)="hideToolbar()"></button>
                        <button
                            class="ql-indent"
                            tooltip="{{ 'Increase indent' | translate }}"
                            container="body"
                            value="+1"
                            (click)="hideToolbar()"></button>
                        <button
                            class="ql-list"
                            tooltip="{{ 'Ordered list' | translate }}"
                            container="body"
                            value="ordered"
                            (click)="hideToolbar()"></button>
                        <button
                            class="ql-list"
                            tooltip="{{ 'Bullet list' | translate }}"
                            container="body"
                            value="bullet"
                            (click)="hideToolbar()"></button>
                        <button
                            class="ql-direction"
                            tooltip="{{ 'Direction' | translate }}"
                            container="body"
                            value="rtl"
                            (click)="hideToolbar()"></button>
                        <button
                            class="ql-header"
                            tooltip="{{ 'Heading 1' | translate }}"
                            container="body"
                            value="1"
                            (click)="hideToolbar()"></button>
                        <button
                            class="ql-header"
                            tooltip="{{ 'Heading 2' | translate }}"
                            container="body"
                            value="2"
                            (click)="hideToolbar()"></button>
                        <button
                            class="ql-clean"
                            tooltip="{{ 'Clear formatting' | translate }}"
                            container="body"
                            (click)="hideToolbar()"></button>
                        <!-- <button class="ql-link" (click)="hideToolbar()"></button> -->
                        <button
                            class="ql-image"
                            tooltip="{{ 'Image' | translate }}"
                            container="body"
                            (click)="hideToolbar()"></button>
                    </div>
                </div>
            </div>
        </quill-editor>
    </div>

    <button
        class="ql-internal-btn formatting-btn btn btn-icon"
        type="button"
        container="body"
        tooltip="{{
            toolbarHelperService.isShowFormatting ? ('Hide formatting' | translate) : ('Show formatting' | translate)
        }}"
        (click)="toolbarHelperService.toggleFormatting()">
        <sb-inline-svg
            class="icon p-0"
            [url]="
                toolbarHelperService.isShowFormatting
                    ? '/sb-tools/theme/images/icons/font-case.svg'
                    : '/sb-tools/theme/images/icons/font.svg'
            ">
        </sb-inline-svg>
    </button>
    <sb-quill-emoji-picker
        [containerClass]="'smiley-popover smiley-popover--bottom-position'"
        (updateQuillSelection)="updateQuillSelection.emit()"
        (emojiSelect)="
            replyTemplateManagerService.chooseReplyTemplate({
                $event: $event.$event,
                templateText: $event.emoji,
                quillEditor,
                quillRange,
                isSmile: true,
            })
        ">
    </sb-quill-emoji-picker>
</div>
